import wxApi from "@/utils/wxsdk";
import store from "@/store";

function wxRegCallback(option) {
  // 将配置注入通用方法
  wxApi.ShareTimeline(option);
  wxApi.ShareAppMessage(option);
}
function wxShareAxios(){
  wxApi.wxAxios()
}
const wxJsApi = {
  wxShare(option) {
    console.log("UITILSHARE");
    console.log("store.state.isShare",store.state.isShare,option);
    // if (!store.state.isShare) {
    //   wxShareAxios();
    // }
    wxShareAxios();
    wxApi.wxRegister(wxRegCallback, option);
  },
  
}

export default wxJsApi


// WEBPACK FOOTER //
// ./src/utils/share.js